  import { useState, useEffect, useCallback } from 'react';

export function useSFGE(apiUrl) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const call = useCallback(async (endpoint, method = 'GET', body = null) => {
    setLoading(true);
    setError(null);
    
    try {
      const options = {
        method,
        headers: { 'Content-Type': 'application/json' }
      };
      
      if (body && method !== 'GET') {
        options.body = JSON.stringify(body);
      }
      
      const response = await fetch(`${apiUrl}${endpoint}`, options);
      const data = await response.json();
      
      if (data.error) {
        throw new Error(data.error);
      }
            return data;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [apiUrl]);

  return { call, loading, error };
}
export function useAlerts(apiUrl) {
  const [alerts, setAlerts] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);

  const fetchAlerts = useCallback(async () => {
    try {
      const response = await fetch(`${apiUrl}/alerts`);
      const data = await response.json();
      setAlerts(data.alerts || []);
      setUnreadCount((data.alerts || []).filter(a => !a.acknowledged).length);
    } catch (err) {
      console.error('Failed to fetch alerts:', err);
    }
  }, [apiUrl]);

  useEffect(() => {
    fetchAlerts();
    const interval = setInterval(fetchAlerts, 30000);
    return () => clearInterval(interval);
  }, [fetchAlerts]);
  const acknowledgeAlert = useCallback(async (id) => {
    try {
      await fetch(`${apiUrl}/alerts/${id}/acknowledge`, { method: 'POST' });
      await fetchAlerts();
    } catch (err) {
      console.error('Failed to acknowledge alert:', err);
    }
  }, [apiUrl, fetchAlerts]);
  return { alerts, unreadCount, acknowledgeAlert, refresh: fetchAlerts };
}
